const initialBlogs = [
  {
    id: 0,
    blogTitle: "Empowering Students Through Guidance",
    blogImage: require("../../assets/images/Home/BlogOne.jpg"),
    blogHeading: "Guidance and Counseling Initiatives",
    blogDescription:
      "Our Guidance and Counseling Initiatives aim to support students in their academic, emotional, and career development through personalized counseling and support systems.",
    blogCreatedDate: "August 10, 2025",
  },
  {
    id: 1,
    blogTitle: "Assistance for Students with Special Needs",
    blogImage: require("../../assets/images/Home/BlogTwo.jpg"),
    blogHeading: "Supporting Every Learner",
    blogDescription:
      "We provide tailored assistance and inclusive learning support for students with special needs to ensure equal access to education and resources.",
    blogCreatedDate: "July 18, 2025",
  },
  {
    id: 2,
    blogTitle: "Comprehensive Student Support Services",
    blogImage: require("../../assets/images/Home/BlogFour.png"),
    blogHeading: "All-Around Student Support",
    blogDescription:
      "From mental health services to academic advising, our student support system is designed to nurture every aspect of a student’s journey.",
    blogCreatedDate: "June 30, 2025",
  },
  {
    id: 3,
    blogTitle: "Value-Added Services for Holistic Development",
    blogImage: require("../../assets/images/Home/BlogThree.png"),
    blogHeading: "Beyond the Classroom",
    blogDescription:
      "Our value-added services include leadership programs, soft skills training, and extracurricular activities that contribute to holistic student growth.",
    blogCreatedDate: "May 22, 2025",
  },
];

// Export so you can import this in other files
export default initialBlogs;

export async function fetchBlogsFromApi() {
  const API_URL = "https://test2.acrossassist.in/api/get_blogs.php";
  try {
    const response = await fetch(API_URL);
    if (!response.ok) {
      throw new Error("Failed to fetch blogs");
    }
    const data = await response.json();
    if (!data.success || !Array.isArray(data.blogs)) return [];
    return data.blogs;
  } catch (error) {
    console.error("Error fetching blogs:", error);
    return [];
  }
}

(async () => {
  const blogs = await fetchBlogsFromApi();
  console.log(blogs);
})();
